module.exports = __webpack_public_path__ + "static/img/22.1d2da7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/park/22.png
// module id = Gr+O
// module chunks = 0